import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import { ButtonClose } from "./style";
import NotificationSapForm from "../notificationSapForm";
import NotificationSapCreateForm from "../notificationSapForm/notificationSapCreateForm.container";
import * as NotificationSapService from "../../../../services/NotificationSapService";
import showDialog from "../../../utils/ShowDialog/ShowDialog";

export const useNotificationSap = (refresh) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const onActionSuccess = async () => {
    if (refresh) {
      refresh();
    }
    handlerClosePopup("ModalForm");
  };

  const createNotification = (productionOrderSapUuid, type) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <NotificationSapCreateForm
                  productionOrderSapUuid={productionOrderSapUuid}
                  type={type}
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => onActionSuccess()}
                />
              </div>
            </div>
          </>
        ),
      }),
    );
  };

  const editNotification = (notificationSap) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <NotificationSapForm
                  notificationSap={notificationSap}
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => onActionSuccess()}
                />
              </div>
            </div>
          </>
        ),
      }),
    );
  };

  const deleteNotification = (notificationSap) => {
    const okAction = async () => {
      try {
        await NotificationSapService.remove(notificationSap.uuid);
        if (refresh) {
          refresh();
        }
      } catch (error) {}
    };

    const cancelAction = () => {};

    showDialog(
      t("forms.notificationSap.dialog.delete.title"),
      t("forms.notificationSap.dialog.delete.text"),
      "question",
      true,
      t("forms.notificationSap.dialog.delete.buttonOk"),
      false,
      okAction,
      t("forms.notificationSap.dialog.delete.buttonNo"),
      cancelAction,
    );
  };

  return {
    createNotification,
    editNotification,
    deleteNotification,
  };
};
